<script setup lang="ts">
import { useField } from 'vee-validate';
import { watch } from 'vue';

const props = defineProps<{
  name: string;
  disabled?: boolean;
  optionHtml?: boolean;
  clearable?: boolean;
}>();

const emit = defineEmits<{
  (e: 'change', newValue: any): void;
  (e: 'clear'): void;
}>();

defineOptions({ inheritAttrs: false });

const { value, errorMessage } = useField(() => props.name);

watch(value, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    emit('change', newValue);
  }
});
</script>

<template>
  <q-select
    v-model="value"
    label=""
    v-bind="$attrs"
    :error="!!errorMessage"
    :error-message="errorMessage"
    :disable="disabled"
    :options-html="optionHtml"
    :clearable="clearable"
    @clear="emit('clear')"
  />
</template>
